import delegateEvent from '../utilities/delegateEvent.js';

export default function Products() {
  let loading = false;
  let overlayOpen = false;
  let currentHref = null;
  let currentOverlay = null;
  let overlays = {};

  const setOpen = (on = true) => {
    if (on) {
      document.documentElement.classList.add('w-has-product-overlay-open');
      overlayOpen = true;
    } else {
      document.documentElement.classList.remove('w-has-product-overlay-open');
      overlayOpen = false;
    }
  };
  const setLoading = (on = true) => {
    if (on) {
      document.documentElement.classList.add('w-is-loading');
      loading = true;
    } else {
      document.documentElement.classList.remove('w-is-loading');
      loading = false;
    }
  };

  return {
    init: () => {
      const target = document.querySelector('main') ?? document.body;

      delegateEvent(document, 'click', '.w-js-product-link', (e) => {
        e.preventDefault();

        const link = e.target.closest('.w-js-product-link');

        if (loading || overlayOpen) return;

        if (link.href === currentHref || overlays[link.href]) {
          if (link.href === currentHref) {
            target.append(currentOverlay);
          } else if (overlays[link.href]) {
            currentOverlay = overlays[link.href];
            target.append(currentOverlay);
          }

          setTimeout(() => {
            setOpen(true);
          }, 10);

          return;
        }

        setLoading(true);
        currentHref = link.href;

        fetch(currentHref, {
          method: 'GET',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
          .then((response) => response.json())
          .then((html) => {
            currentOverlay = document.createElement('div');
            currentOverlay.innerHTML = html;
            target.append(currentOverlay);

            setTimeout(() => {
              setOpen(true);
              setLoading(false);
            }, 10);

            if (!overlays[currentHref]) {
              overlays[currentHref] = currentOverlay;
            }
          });
      });

      delegateEvent(document, 'click', '.w-js-product-overlay-close', (e) => {
        e.preventDefault();

        setOpen(false);

        setTimeout(() => {
          currentOverlay.remove(); // remove from dom
        }, 300);
      });
    },
  };
}
